<template>
<div class="table_wrap pt30">
    <div class="table_search row has_bc">
        <el-row>
            <el-col :span="12">
            </el-col>
            <el-col class="text_right" :span="12">
                <el-select
                    v-model="pageRow"
                    @change="setPageRow()"
                >
                    <el-option
                        v-for="row in pageRows"
                        :key="row"
                        :label="`${row}개 씩보기`"
                        :value="row"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
    </div>
    <el-table
        :data="pointData"
        style="width: 100%"
        empty-text="데이터가 없습니다."
    >
        <el-table-column
            class="table_no"
            type="index"
            label="#"
            width="70"
            class-name="num"
            :index="tableIndex"
        >
        </el-table-column>

        <el-table-column
            label="신청번호" width="85" class-name="text-center" prop="pbs_code"
        >
        </el-table-column>

        <el-table-column
            label="신청 스토어 명" width="" class-name="text-center" prop="s_name"
        >
        </el-table-column>

        <el-table-column
            label="아이디" width="" class-name="text-center" prop="mb_id"
        >
        </el-table-column>

        <el-table-column
            label="이름 / 닉네임" width="" class-name="text-center"
        >
            <template slot-scope="scope">
                <div>{{ scope.row.mb_name }}/{{ scope.row.mb_nick }}</div>
            </template>
        </el-table-column>

        <el-table-column
            label="전환 신청 메일 주소" width="" class-name="text-center" prop="sm_email"
        >
        </el-table-column>

        <el-table-column
            label="신청 포인트" width="" class-name="text-center"
        >
            <template slot-scope="scope">
                <div>{{ Math.abs(scope.row.p_point) }}</div>
            </template>
        </el-table-column>

        <el-table-column
            label="전환 신청일" width="" class-name="text-center" prop="created_at"
        >
        </el-table-column>

        <el-table-column
                         align="center"
                         width="100"
                         label="상세정보"
                         class-name="table_bottons"
        >
            <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="danger"
                    v-if="scope.row.pbs_status === 0"
                    @click="openModal(scope.row)">미처리
                </el-button>
                <el-button
                    size="mini"
                    type="success"
                    v-if="scope.row.pbs_status === 1"
                    @click="openModal(scope.row)">보류
                </el-button>
                <el-button
                    size="mini"
                    type="warning"
                    v-if="scope.row.pbs_status === 2"
                    @click="openModal(scope.row)"
                >거절
                </el-button>
                <el-button
                    size="mini"
                    type="primary"
                    v-if="scope.row.pbs_status === 3"
                    @click="openModal(scope.row)"
                >승인됨
                </el-button>
            </template>
        </el-table-column>
    </el-table>
    <point-status-modal :getObj ="selectRow" ></point-status-modal>
</div>
</template>

<script>
import PointStatusModal from "@/components/modal/PointStatusModal";

export default {
    name: "PointListStoreLayout",
    mixins: [],
    components: {PointStatusModal},
    inject: ['setPage', 'setSort'],
    provide() {
        return {}
    },
    props: {
        pointData: {
            default: () => {
            }
        },
        paginationData: {
            paginationData: {default: {page: 1, size: 10, total: 0}},
        },
    },
    data() {
        return {
            pageRow: 10,
            pageRows: [10, 30, 50],
            selectRow: {},
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        tableIndex(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },

        setPageRow() {
            this.setPage('size', this.pageRow)
        },

        openModal(row) {
            this.selectRow = row;
            this.$modal.show('point-status-modal')
        },
    },
    watch: {
        'paginationData.size': {
            deep: true,
            handler: function (val, oldVal) {
                this.pageRow = this.paginationData.size;
            }
        }
    },
}
</script>

<style scoped>

</style>
